import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getSkillsForTree = api((treeId) =>
    query(
        gql`
            query GetSkillsForTree($treeId: String!) {
                getSkillsForTree(treeId: $treeId) {
                    id
                    skill {
                        Skilling
                        SkillingCode
                        CoreSkillingID
                    }
                }
            }
        `,
        { treeId },
        { returns: "getSkillsForTree" }
    )
)
